import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import React, { useEffect } from 'react';
import api from '../../../../api';
import { resetState } from './action/waf-error-reducer';

const WafErrorModal = () => {
  const wafErrorData = useSelector((state: any) => state.wafError, shallowEqual);

  const { t } = useTranslation();
  const dispatch = useDispatch();

  useEffect(() => {
    const auditError = async () => {
      if (wafErrorData.correlationId) {
        try {
          await api.technicalError(wafErrorData.correlationId, wafErrorData.url, wafErrorData.method);
          // eslint-disable-next-line no-empty
        } catch (ignore) {}
      }
    };
    auditError();
  }, [wafErrorData.correlationId, wafErrorData.url, wafErrorData.method]);

  const onClose = () => dispatch(resetState());

  return (
    <Modal show={wafErrorData.displayModal} onHide={onClose}>
      <Modal.Header closeButton>
        <h3>{t('modal.wafErrorModal.title')}</h3>
      </Modal.Header>
      <Modal.Body>{`${t('modal.wafErrorModal.body')} ${wafErrorData.correlationId}`}</Modal.Body>
    </Modal>
  );
};

export default WafErrorModal;
